import React from 'react';
import ReactDOM from 'react-dom';
import SeoSubCategory from './SeoSubCategory';

const componentElm = typeof document !== 'undefined' && document.getElementById('SeoSubCategory-component');

if (componentElm) {
    const initialState = window.initialData.SeoSubCategory;

    ReactDOM.render(
        <SeoSubCategory {...initialState}/>,
        componentElm
    );
}

export default SeoSubCategory;



// WEBPACK FOOTER //
// ./src/index.js